module.exports = __webpack_public_path__ + "media/images/bentley-4304d5344b4753b5e82a92f24d21c771.png";